module.exports = __webpack_public_path__ + "static/brand3-c3409815458419fb00b7e5142c6642eb.png";